import { testimonials } from "@/mocks/categories";

export default function Testimonials() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">
            Depoimentos
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            O Que Nossos
            <br />
            <span className="text-foreground-500">Usuários Dizem</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {testimonials.slice(0, 3).map((t, idx) => (
            <div
              key={t.name}
              className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-5">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/40">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-4 md:mt-6">
          {testimonials.slice(3, 5).map((t) => (
            <div
              key={t.name}
              className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-7 flex items-center gap-5"
            >
              <img
                src={t.avatar}
                alt={t.name}
                className="w-14 h-14 rounded-full object-cover flex-shrink-0"
              />
              <div>
                <div className="flex items-center gap-1 mb-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-amber-400 text-xs"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-2">
                  "{t.text}"
                </p>
                <p className="text-xs font-semibold text-foreground-800">
                  {t.name}{" "}
                  <span className="text-foreground-500 font-normal">— {t.role}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}